<script setup>
import { getLocalStorage } from "@/service/LocalStorageService";
import { ref } from "vue";
import AppMenuItem from "./AppMenuItem.vue";
import { getMenuModel } from "./menuModel.js";

const isAdmin = getLocalStorage("userData").isAdmin;
const model = ref(getMenuModel(isAdmin));
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item
        v-if="!item.separator"
        :item="item"
        :index="i"
      ></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<style lang="scss" scoped></style>
